/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import AuthService from 'cio/services/auth';

interface ViewerRestrictedTooltipArgs {
  restriction?: boolean;
  readOnly: boolean;
}

export default class ViewerRestrictedTooltip extends Component<ViewerRestrictedTooltipArgs> {
  @service auth!: AuthService;

  get showTooltip() {
    if (!this.args.restriction) {
      return this.args.readOnly;
    }
    return this.args.readOnly && this.args.restriction;
  }
}
